/**
 * Phonics Letter Kk — 课程数据配置
 *
 * 媒体资源基础路径（对应服务器 /media/phonics/kk/）
 *
 * 页面结构：
 * P3: Song (Kk.mp4)
 * P4: 4格词汇（media2/3/4/5.mp4）
 * P5: Learn the words (1) — vocab-dual — at park + kick ball
 * P6: Learn the words (2) — vocab-dual — zoo + hill
 * P7: Learn the words (3) — 单图 kiss（无句子）
 * P9: Story 1 (media1.mp4, poster=image18)
 * P10: Story 2 (media1.mp4, poster=image19)
 * P11: Story 3 (media1.mp4, poster=image20)
 * P14: Chant (Kk.mp4)
 */

const MEDIA_BASE = '/media/phonics/kk';
const V = 'v1';

export const letterData = {
  letter: 'Kk',
  title: 'Phonics Letter Kk',
  subtitle: 'Kk — Koala',

  mediaBase: MEDIA_BASE,

  // P3/P14: Song/Chant（共用 Kk.mp4，时段 00:12–01:26）
  songVideo: {
    src: `${MEDIA_BASE}/Kk.mp4?${V}`,
    poster: `${MEDIA_BASE}/Kk.png?${V}`,
    startTime: 12,
    endTime: 86,
  },

  // P4: 4格词汇视频（来自 PPT media2-5）
  wordVideos: [
    { id: 1, src: `${MEDIA_BASE}/video_s3_word1.mp4?${V}`, cover: `${MEDIA_BASE}/image8.png?${V}` },
    { id: 2, src: `${MEDIA_BASE}/video_s3_word2.mp4?${V}`, cover: `${MEDIA_BASE}/image9.png?${V}` },
    { id: 3, src: `${MEDIA_BASE}/video_s3_word3.mp4?${V}`, cover: `${MEDIA_BASE}/image10.png?${V}` },
    { id: 4, src: `${MEDIA_BASE}/video_s3_word4.mp4?${V}`, cover: `${MEDIA_BASE}/image11.png?${V}` },
  ],

  storySections: [

    // ============================================================
    // Section 1: P5 Learn the words (1) — 左图右文 — at park + kick ball
    // ============================================================
    {
      label: 'Learn the words (1)',
      layout: 'vocab-left-text-right',
      videos: [
        { src: `${MEDIA_BASE}/image13.png?${V}`, poster: `${MEDIA_BASE}/image13.png?${V}` },
        { src: `${MEDIA_BASE}/image14.png?${V}`, poster: `${MEDIA_BASE}/image14.png?${V}` },
      ],
      lines: [
        // 左图右侧文字
        { en: 'at park', cn: '在公园', audioEn: `${MEDIA_BASE}/w_en_at_park.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_at_park.mp3?${V}` },
        { en: 'Koala is at the park.', cn: '考拉在公园。', audioEn: `${MEDIA_BASE}/s_en_koala_is_at_the_park.mp3?${V}`, audioCn: `${MEDIA_BASE}/s_cn_koala_is_at_the_park.mp3?${V}` },
        { en: 'kick ball', cn: '踢球', audioEn: `${MEDIA_BASE}/w_en_kick_ball.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_kick_ball.mp3?${V}` },
        { en: 'Koala kicks a ball.', cn: '考拉踢球。', audioEn: `${MEDIA_BASE}/s_en_koala_kicks_a_ball.mp3?${V}`, audioCn: `${MEDIA_BASE}/s_cn_koala_kicks_a_ball.mp3?${V}` },
      ],
    },

    // ============================================================
    // Section 2: P6 Learn the words (2) — 左图右文 — zoo + hill
    // ============================================================
    {
      label: 'Learn the words (2)',
      layout: 'vocab-left-text-right',
      videos: [
        { src: `${MEDIA_BASE}/image15.png?${V}`, poster: `${MEDIA_BASE}/image15.png?${V}` },
        { src: `${MEDIA_BASE}/image17.png?${V}`, poster: `${MEDIA_BASE}/image17.png?${V}` },
      ],
      lines: [
        { en: 'zoo', cn: '动物园', audioEn: `${MEDIA_BASE}/w_en_zoo.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_zoo.mp3?${V}` },
        { en: 'Kangaroo is at the zoo.', cn: '袋鼠在动物园。', audioEn: `${MEDIA_BASE}/s_en_kangaroo_is_at_the_zoo.mp3?${V}`, audioCn: `${MEDIA_BASE}/s_cn_kangaroo_is_at_the_zoo.mp3?${V}` },
        { en: 'hill', cn: '山', audioEn: `${MEDIA_BASE}/w_en_hill.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_hill.mp3?${V}` },
        { en: 'King is on the hill.', cn: '国王在山上。', audioEn: `${MEDIA_BASE}/s_en_king_is_on_the_hill.mp3?${V}`, audioCn: `${MEDIA_BASE}/s_cn_king_is_on_the_hill.mp3?${V}` },
      ],
    },

    // ============================================================
    // Section 3: P7 Learn the words (3) — 左图右文 — kiss（单图）
    // ============================================================
    // Section 3: P7 Learn the words (3) — 左图右文 — kiss
    // ============================================================
    {
      label: 'Learn the words (3)',
      layout: 'vocab-left-text-right',
      videos: [
        { src: `${MEDIA_BASE}/image16.png?${V}`, poster: `${MEDIA_BASE}/image16.png?${V}` },
      ],
      lines: [
        { en: 'kiss', cn: '亲', audioEn: `${MEDIA_BASE}/w_en_kiss.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_kiss.mp3?${V}` },
      ],
    },

    // ============================================================
    // Section 4: P9 Story 1 — 00:30–00:44
    // ============================================================
    {
      label: 'Learn the Story (1)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/media1.mp4?${V}`, poster: `${MEDIA_BASE}/image18.png?${V}`, startTime: 30, endTime: 44 }],
      lines: [
        { en: 'Where is Koala?', cn: '考拉在哪里？', audioEn: `${MEDIA_BASE}/story1_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_1.mp3?${V}` },
        { en: 'Koala is at the park.', cn: '考拉在公园。', audioEn: `${MEDIA_BASE}/story1_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_2.mp3?${V}` },
        { en: 'Kick, kick. Koala kicks a ball.', cn: '踢、踢。考拉踢球。', audioEn: `${MEDIA_BASE}/story1_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_3.mp3?${V}` },
      ],
    },

    // ============================================================
    // Section 5: P10 Story 2 — 00:48–01:01
    // ============================================================
    {
      label: 'Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/media1.mp4?${V}`, poster: `${MEDIA_BASE}/image19.png?${V}`, startTime: 48, endTime: 61 }],
      lines: [
        { en: 'Where is Kangaroo?', cn: '袋鼠在哪里？', audioEn: `${MEDIA_BASE}/story2_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_1.mp3?${V}` },
        { en: 'Kangaroo is at the zoo.', cn: '袋鼠在动物园。', audioEn: `${MEDIA_BASE}/story2_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_2.mp3?${V}` },
        { en: 'Kangaroo kicks a ball.', cn: '袋鼠踢球。', audioEn: `${MEDIA_BASE}/story2_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_3.mp3?${V}` },
      ],
    },

    // ============================================================
    // Section 6: P11 Story 3 — 01:05–01:19
    // ============================================================
    {
      label: 'Learn the Story (3)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/media1.mp4?${V}`, poster: `${MEDIA_BASE}/image20.png?${V}`, startTime: 65, endTime: 79 }],
      lines: [
        { en: 'Where is King?', cn: '国王在哪里？', audioEn: `${MEDIA_BASE}/story3_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story3_cn_1.mp3?${V}` },
        { en: 'King is on the hill.', cn: '国王在山上。', audioEn: `${MEDIA_BASE}/story3_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story3_cn_2.mp3?${V}` },
        { en: 'King flies a kite.', cn: '国王放风筝。', audioEn: `${MEDIA_BASE}/story3_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story3_cn_3.mp3?${V}` },
      ],
    },

  ],

  // 封面背景图
  coverBg: `${MEDIA_BASE}/image1.jpeg`,
  coverPoster: `${MEDIA_BASE}/Kk.png`,
};

export default letterData;
